import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { hasPerm } from '../utils/permissions'

// Permite restringir por roles permitidos y/o por un permiso específico
// Si se especifican ambos, alcanza con cumplir uno (rol o permiso)
const PrivateRoute = ({ children, roles, perm }) => {
  const { user } = useSelector((state) => state.auth)

  // Si no hay usuario logueado → redirige al login
  if (!user) {
    return <Navigate to="/login" />
  }

  if (Array.isArray(roles) && roles.length > 0) {
    if (roles.includes(user.role)) return children
    // Si no está en roles, permitimos pasar si tiene el permiso requerido
    if (perm && hasPerm(user, perm)) return children
    return <Navigate to="/dashboard" />
  }

  if (perm && !hasPerm(user, perm)) {
    return <Navigate to="/dashboard" />
  }

  // Si hay usuario → renderiza el contenido protegido
  return children
}

export default PrivateRoute
